import * as React from "react";
import { api, user } from "src/services/api";
import { reload } from "src/services/browser";

import Modal from "../ui/Modal";
import { MustAuth } from "../frontend";
import { BtnInstantPay } from "../ecommerce";

interface Props {
    id: any;
    crediti: number;
    onClose: Function;
    onRicaricaCrediti: Function;
}
interface State {
}
export class DocenteRichiestaContatto extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    
    async save() {
    }
    
    cancel() {
        const { onClose } = this.props;
        if (onClose) {
            onClose();
        }
    }
  
    render() {
        const { children, id, crediti } = this.props;
        const { } = this.state;
        
        return (
            <Modal
              open={true}
              backdrop={true}
              icon={"binoculars_filled"}
              className="docente_RichiestaContatto ecommerce_AcquistiScuola_bigheader"
              onClose={() => this.cancel()}
            >
              <header>
                <h2>Visualizza i dati di contatto del docente</h2>
                <p>Il costo è di soli <em>{crediti} crediti</em></p>
              </header>
              <section>
                <BtnInstantPay
                    action="contattiDocente"
                    params={{id}}
                    label="Visualizza contatto"
                    crediti={crediti}
                    onPay={() => reload()}
                    onCancel={() => this.cancel()}
                />
              </section>
              {user.crediti >= crediti &&
              <footer>
                <span className="icon-info" />
                <div>
                    Sblocco immediato dei dati di contatto del docente<br />
                    Inserimento in automatico tra "I Tuoi Preferiti"
                </div>
              </footer>
              }
            </Modal>
        );
    }
}

interface StateToggler {
    open: "auth" | "modal" | null;
}
export default class DocenteRichiestaContattoToggler extends React.Component<any, StateToggler> {
    constructor(props) {
        super(props);
        this.state = {
            open: null
        };
    }
    
    execute() {
        if (!user) {
            this.setState({open: "auth"});
        } else {
            this.setState({open: "modal"});
        }
    }
    
    render() {
        const { open = null } = this.state;
        const props = {
            ...this.props,
            onClose: () => this.setState({open: null})
        } as any;
        return (
        <>
            {(/*true ||*/ open === "auth") &&
            <MustAuth
                subtitle={() => (<>l'iscrizione è totalmente gratuita,<br /> non ci sono provvigioni</>)}
                content={() => (<>Per contattare un insegnante<br /> devi effettuare il <em>login su Schoolvisor</em></>)}
                onClose={() => this.setState({open: null})}
            />
            }
            {open === "modal" &&
            <DocenteRichiestaContatto {...props} />
            }
            <span onClick={() => this.execute() }>
                {this.props.children}
            </span>
        </>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/docente/RichiestaContatto.tsx